import classnames from 'classnames';
import { bool, func, number, oneOf } from 'prop-types';
import { Component } from 'react';

import { getElementTop } from 'shared/utils/dom';
import { getText } from 'shared/utils/Text';

import CircleSpinner from '../icon/CircleSpinner';
import ErrorCircle from '../icon/ErrorCircle';
import WithWindowSize from '../WithWindowSize';
import BetHeaderButton from './BetHeaderButton';
import BetHeaderItem from './BetHeaderItem';
import BetHeaderPopup from './BetHeaderPopup';

export default WithWindowSize()(
  class BetInfo extends Component {
    static propTypes = {
      popupVisible: bool.isRequired,
      indicator: oneOf(['warning', 'spinner', null]),
      onIndicatorClick: func,
      onTogglePopup: func.isRequired,
      popupRefHandler: func.isRequired,
      renderBetData: func.isRequired,
      renderPopupBetData: func.isRequired,
      renderPopupReductionSummary: func.isRequired,
      windowHeight: number.isRequired,
    };

    state = {};

    UNSAFE_componentWillReceiveProps(nextProps) {
      const { indicator, windowHeight, popupVisible } = nextProps;

      if (!indicator && this.state.indicatorVisible && !this.timer) {
        this.timer = window.setTimeout(() => {
          this.timer = undefined;
          this.setState({
            indicatorVisible: false,
          });
        }, 250);
      } else if (
        indicator &&
        (indicator !== this.state.indicator || !this.state.indicatorVisible)
      ) {
        window.clearTimeout(this.timer);
        this.timer = undefined;
        this.setState({
          indicator,
          indicatorVisible: true,
        });
      }

      if (windowHeight !== this.props.windowHeight && popupVisible) {
        this.ensurePopupInScreen();
      }
    }

    componentDidUpdate() {
      const { popupVisible } = this.props;
      if (popupVisible) {
        this.ensurePopupInScreen();
      }
    }

    componentWillUnmount() {
      window.clearTimeout(this.timer);
    }

    onPopupRef = ref => {
      this.popupNode = ref;
      this.props.popupRefHandler(ref);
    };

    onWindowResize = () => {
      this.ensurePopupInScreen();
    };

    ensurePopupInScreen = () => {
      if (!this.popupNode) {
        return;
      }

      const node = this.popupNode;
      const top = getElementTop(node);
      const height = node.scrollHeight;
      const maxHeight = window.innerHeight - top - 15;

      node.style.maxHeight = height > maxHeight ? `${maxHeight}px` : 'none';
    };

    render() {
      const {
        popupVisible,
        onIndicatorClick,
        onTogglePopup,
        popupRefHandler,
        renderBetData,
        renderPopupBetData,
        renderPopupReductionSummary,
      } = this.props;

      const { indicator, indicatorVisible } = this.state;

      return (
        <BetHeaderItem className="betinfo">
          <div
            className={classnames('indicator', {
              'indicator--visible': indicatorVisible,
            })}
            onClick={onIndicatorClick}
          >
            {indicator === 'spinner' && <CircleSpinner />}
            {indicator === 'warning' && <ErrorCircle outline />}
          </div>

          <BetHeaderButton
            fullWidth={false}
            active={popupVisible}
            className="betheader-button--betinfo"
            onClick={onTogglePopup}
            buttonRef={popupRefHandler}
          >
            {renderBetData(popupVisible)}
          </BetHeaderButton>

          <BetHeaderPopup
            className="betinfo-popup"
            visible={popupVisible}
            refHandler={this.onPopupRef}
          >
            <div className="betinfo-popup-betdata betinfo-popup-wrapper">
              <h2>{getText('bet-popup-bettable-header')}</h2>
              {renderPopupBetData(popupVisible)}
            </div>
            <div className="betinfo-popup-wrapper">
              {renderPopupReductionSummary(
                popupVisible,
                this.ensurePopupInScreen,
              )}
            </div>
          </BetHeaderPopup>
        </BetHeaderItem>
      );
    }
  },
);
